import React from 'react';
import IEmptyState from "EmptyState";
import PictureFrame from "CommonControls/PictureFrame";
import { PictureFrameStyle } from "CommonControls/PictureFrameStyle";

interface IServiceItemProps {
    title: string;
    iconUrl: string;
}

export default class ServiceItem extends React.Component<IServiceItemProps, IEmptyState> {
    constructor(props: IServiceItemProps) {
        super(props);
    }

    public render() {
        return (
            <div className="item">
                <div className="picture-frame-container">
                    <PictureFrame pictureUrl={this.props.iconUrl} style={PictureFrameStyle.CircleFit} />
                </div>
                <div className="text">
                    {this.props.title}
                </div>
            </div>
        );
    }
}